/**
 * Web Form API Service
 */

import { apiClient } from './client'
import type {
  LeadWebListResponse,
  LeadWebFilterParams,
  LeadWebResponse,
  ConvertToLeadResponse,
} from '@/types/api'

/**
 * Get paginated list of web form leads with optional filters
 */
export async function getWebFormLeads(params?: LeadWebFilterParams): Promise<LeadWebListResponse> {
  return apiClient.get<LeadWebListResponse>('/web-forms/leads', { params })
}

/**
 * Convert a web form submission to a lead
 */
export async function convertToLead(
  id: string,
  data: { assigned_to: string },
): Promise<ConvertToLeadResponse> {
  return apiClient.post<ConvertToLeadResponse>(`/web-forms/leads/${id}/convert`, data)
}

async function markConverted(
  id: string,
  convertedLeadId: string,
): Promise<LeadWebResponse> {
  return apiClient.patch<LeadWebResponse>(`/web-forms/leads/${id}/mark-converted`, {
    converted_lead_id: convertedLeadId,
  })
}

export const webFormService = {
  getWebFormLeads,
  convertToLead,
  markConverted,
}
